// src/skillPositions.js
export const generateSkillPositions = (allSkills) => {
  // Define orbit sizes (smaller to fit on screen)
  const orbitSizes = [140, 230, 320]; // Inner, Middle, Outer orbit radii
  
  // Define how many skills per orbit: 6 ML tools, 8 languages, 4 web dev
  const skillsPerOrbit = [6, 8, 4]; // ← Changed from [6, 6, 4]
  
  const positions = [];
  let skillIndex = 0;

  skillsPerOrbit.forEach((count, orbitIndex) => {
    const orbitSize = orbitSizes[orbitIndex];
    
    for (let i = 0; i < count && skillIndex < allSkills.length; i++) {
      // Base angle calculation - evenly distributed
      const angleStep = 360 / count;
      const baseAngle = angleStep * i;
      
      // Add rotation offset per orbit (creates spiral effect)
      const orbitRotation = orbitIndex * 15;
      
      // Add organic offset using deterministic "randomness"
      // Using sine function with prime numbers for natural variation
      const randomOffset = Math.sin(skillIndex * 7.13) * 8;
      
      // Final angle with all offsets
      const angle = baseAngle + orbitRotation + randomOffset;
      
      // Calculate x, y coordinates
      const x = Math.cos((angle * Math.PI) / 180) * orbitSize;
      const y = Math.sin((angle * Math.PI) / 180) * orbitSize;
      
      positions.push({
        left: `calc(50% + ${x}px - 37.5px)`, // 37.5px is half of 75px skill item
        top: `calc(50% + ${y}px - 37.5px)`,
        animationDelay: `${skillIndex * 0.08}s`
      });
      
      skillIndex++;
    }
  });
  
  return positions;
};